import React, { useEffect } from 'react';
import { CountdownProvider } from './contexts/CountdownContext';
import { initMetaPixel } from './utils/metaPixel';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/Hero';
import { BonusHighlight } from './components/BonusHighlight';
import { Vsl } from './components/Vsl';
import { Agitation } from './components/Agitation';
import { OfferStack } from './components/OfferStack';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CountdownProvider data-id="element-0" data-mp="2wjql9i09eorx">
      <div className="w-full bg-bone font-body" data-id="element-1" data-mp="2wifgbev2vaz8">
        <StickyBar data-id="element-2" data-mp="28u5zysgmvffh" />
        <main data-id="element-3" data-mp="28tmej1rry8wp">
          <Hero data-id="element-4" data-mp="28t4kmbsl46ry" />
          <Vsl data-id="element-5" data-mp="28sl48zil1qg1" />
          <BonusHighlight data-id="element-6" data-mp="28s2y9b64bxux" />
          <Agitation data-id="element-7" data-mp="23vuo6c6s2uum" />
          <OfferStack data-id="element-8" data-mp="23u9uspw79hyc" />
          <Testimonials data-id="element-9" data-mp="23ut9lxqjzq85" />
          <Faq data-id="element-10" data-mp="23ti6m04xmmi3" />
          <FinalCta data-id="element-11" data-mp="3ik7fce9tu7pl" />
        </main>
        <Footer data-id="element-12" data-mp="3ij64oawq3n8e" />
      </div>
    </CountdownProvider>;
}